/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
export default function MoveEntityController($scope, $mdDialog,
                                             entityService,
                                             placeholderText,
                                             notFoundText,
                                             requiredText,
                                             parentEntityId,
                                             entity,
                                             targetRootEntityId,
                                             targetEntityType, targetEntitySubtypes) {

    var vm = this;

    vm.placeholderText = placeholderText;
    vm.notFoundText = notFoundText;
    vm.requiredText = requiredText;

    vm.entity = entity;
    vm.parentEntityId = parentEntityId;
    vm.targetRootEntityId = targetRootEntityId;
    vm.targetEntityType = targetEntityType;
    vm.targetEntitySubtypes = targetEntitySubtypes;

    vm.targetEntityId = null;
    vm.move = move;
    vm.cancel = cancel;


    function cancel() {
        $mdDialog.cancel();
    }

    function move() {
        entityService.moveEntity( vm.entity.id, vm.parentEntityId, vm.targetEntityId ).then(
            function success() {
                $scope.theForm.$setPristine();
                $mdDialog.hide(vm.targetEntityId);
            }
        );
    }
}